import { resolveScreenImageIdAtGlobalTime } from '@/animation/resolveScreenImageIdAtGlobalTime'
import type { AnimationLayer } from '@/types/animationLayer'

/**
 * 解析当前时刻用于栅格屏幕（非视频解码）的 blob URL：多图栈、单图 legacy、或无。
 *
 * @param layer - 图层
 * @param globalTimeSeconds - 全局时间轴（秒）
 */
export function effectiveScreenRasterObjectUrl(
  layer: AnimationLayer,
  globalTimeSeconds: number,
): string | null {
  if (layer.screenMediaType === 'video') return null
  if (layer.screenMediaType === 'image' && layer.screenImages.length > 0) {
    const id = resolveScreenImageIdAtGlobalTime(layer, globalTimeSeconds)
    return layer.screenImages.find((x) => x.id === id)?.textureSrc ?? null
  }
  if (layer.screenMediaType === 'image' && layer.screenTextureSrc) return layer.screenTextureSrc
  return null
}
